import { BAILocale } from '.';
import es_ES from 'antd/es/locale/es_ES';

const localeValue: BAILocale = {
  lang: 'es',
  antdLocale: es_ES,
};

export default localeValue;
